export default __webpack_public_path__ + "static/media/catalog_title_img.bf047627.svg";